import React, { useEffect, useState, useContext } from 'react';
import {
  AppContext,
  EventEmitter,
  DATE_TIME_FORMAT,
  useActivityTracker,
  formatDataForSelectDropdown,
  toast,
  sendMessageToContentJS,
  COMMON_CONSTANTS,
  useProduct,
  EventEmitterWithIndex,
  useCheckFeatureGating
} from '@nile/components';
import {
  useCachedQuery,
  GET_ALL_TIMER_ENTRIES,
  GET_AUTO_START_TIMER_INFO,
  MockTicketClient,
  AccountClient,
  GET_WHITELISTED_SERVICE_ITEMS,
  CREATE_WORKLOG_ENTRIES,
  UPDATE_WORKLOG_ENTRY,
  CREATE_WORKLOG_TIMER_ENTRY,
  UPDATE_WORKLOG_TIMER_ENTRY,
  DELETE_WORKLOG_TIMER,
  CREATE_WORKLOG_FROM_TIMERS,
  TicketClient,
  ADD_WORKLOG_ENTRIES,
  GET_WORKLOG_ENTRIES,
  DELETE_WORKLOG_ENTRY,
  GET_AI_WORKLOG_NOTE,
  MLClient,
  AI_WORKLOGNOTE_GENERATE,
  GET_ELIGIBLE_SERVICE_ITEMS
} from '@nile/graphql';
import WorklogManualTimerForm from '@nile/components/src/Containers/NewWorklog/WorklogManualTimerform';
import { SkeletonBodyText } from '@superops/ui-design-system';
import dayjs from 'dayjs';
import { useQuery, useMutation, useLazyQuery } from '@apollo/client';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { removePropertiesForItProduct } from '@nile/itsm';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const WorklogManualTimerFormWrapper = styled.div`
  .timer-actions {
    right: 10px;
    top: 10px;
  }
`;

function WorklogManualTimer(props) {
  const {
    intl,
    editMode,
    ticket,
    project,
    workItem,
    timer,
    handleClose,
    module,
    associateWorkItem,
    workLogEdit,
    refetchTimerEntry,
    highlightRunningTimer,
    allowEmptyState,
    allTimerEntries,
    forwardedRef,
    hideCancel,
    hideWorkitem,
    hideDelete,
    handleParentClose,
    worklogAdd,
    globaltimerSection,
    repositionPopup,
    disableCloseOnSuccess,
    closeOnCancel,
    aiWorklogNotes,
    timerNote,
    handleWorklogCreated,
    isAgentChat = false,
    disableSaveTimer = false,
    threadData = [],
    taskId,
    hideWorklogTask,
    hideTaskWorkItem,
    taskViewOnly,
    hideBlockItemConsumptionInfo
  } = props;
  const appContext = useContext(AppContext);
  const currentUser = appContext.user;
  const flags = useFlags();
  const contractsNew = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  const [timerItem, setTimerItem] = useState(
    timer?.[contractsNew ? 'serviceCatalogItem' : 'serviceItem'] || null
  );
  const [timerId, setTimerId] = useState(timer?.timerId || null);
  const [defaultTimerItem, setDefaultTimerItem] = useState(null);

  const [comments, setComments] = useState(timer?.notes || null);
  const [billDateTime, setBillDateTime] = useState(
    timer?.billDateTime
      ? dayjs().format(timer.billDateTime)
      : dayjs().format(DATE_TIME_FORMAT)
  );
  const [billable, setBillable] = useState(timer?.billable || true);
  const [afterHours, setAfterHours] = useState(timer?.afterHours || false);
  const [qty, setQty] = useState(timer?.qty || null);
  const [segments, setSegments] = useState(timer?.segments || []);
  const [associatedWorkItem, setAssociatedWorkItem] = useState(
    !isEmpty(workItem) ? workItem : null
  );
  const [loading, setLoading] = useState(false);
  const [runningTimerEntries, setRunningTimerEntries] = useState(null);
  const [aiGeneratedNote, setAIgeneratedNote] = useState(false);
  const isMSPProduct = useProduct('MSP');

  const formatAndSetSegments = (segmentsArr) => {
    const formattedSegments = segmentsArr.map((segment) => {
      return { ...segment, timespent: segment?.timespent * 60 };
    });
    setSegments(formattedSegments || []);
  };

  const getWorklogNote = (arr) => {
    let str = '';
    arr.forEach((note, idx) => {
      if (idx > 0) {
        str = str + `\n${note}`;
      } else {
        str = `${note}`;
      }
    });
    return str;
  };

  const [aiWorklogNoteLoading, setAiWorklogNoteLoading] = useState(false);

  const handleAIError = () => {
    setAiWorklogNoteLoading(false);
  };

  const skipAIWorklogNotes = !aiWorklogNotes || !timer?.notes;

  const [getAiWorklog] = useLazyQuery(GET_AI_WORKLOG_NOTE, {
    client: MLClient,
    skip: skipAIWorklogNotes,
    fetchPolicy: 'no-cache',
    variables: {
      text: timer?.notes
    },
    onCompleted(res) {
      setAiWorklogNoteLoading(false);
      if (!isEmpty(res?.convertReplyToAIWorklog)) {
        const noteString = getWorklogNote(res?.convertReplyToAIWorklog);
        setComments(noteString);
        setAIgeneratedNote(true);
        setTimeout(() => {
          if (repositionPopup) {
            repositionPopup();
          }
        }, 20);
      }
    }
  });

  const currentProduct = useProduct();
  const [
    createWorklogTimerEntryWithInterceptor,
    {
      loading: createWorklogTimerEntryLoading,
      data: createdWorklogTimerEntry,
      error: createWorklogTimerEntryError
    }
  ] = useMutation(CREATE_WORKLOG_TIMER_ENTRY, {
    onCompleted({ createWorklogTimerEntry: currentCreatedTimer }) {
      if (currentCreatedTimer) {
        const currentTimer = currentCreatedTimer;
        const currentTimerItem =
          currentTimer[contractsNew ? 'serviceCatalogItem' : 'serviceItem'];
        const currentBillable = currentTimer.billable;
        const currentTimeSpent = currentTimer.timespent;
        const currentTimerState = currentTimer.state;
        const currentTimerRunning = currentTimer.running;
        const currentNotes = currentTimer.notes;
        const currentWorkItem = currentTimer.workItem;
        setTimerItem(currentTimerItem);
        setBillable(currentBillable);
        setComments(currentNotes);
        formatAndSetSegments(currentTimer?.segments || []);
        setTimerId(currentTimer.timerId);
        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        sendMessageToContentJS('refetchGlobalTimers');

        const event = globaltimerSection
          ? 'Started timer from widget'
          : `Started timer from a ${(
              currentWorkItem?.module || 'TICKET'
            ).toLowerCase()}`;
        useActivityTracker({
          event: event
        });

        if (handleClose && !disableCloseOnSuccess) handleClose();
      }
    }
  });
  async function createWorklogTimerEntry(variables) {
    try {
      const updatedPayload = removePropertiesForItProduct(
        variables,
        'createWorklogTimerEntry',
        currentProduct
      );
      return await createWorklogTimerEntryWithInterceptor(updatedPayload);
    } catch (ex) {
      return ex;
    }
  }

  const isItProduct = useCheckIsItProduct();

  const [
    createWorklogEntryFromTimer,
    {
      loading: createWorklogEntryFromTimerLoading,
      data: worklogEntry,
      error: createWorklogEntryFromTimerError
    }
  ] = useMutation(CREATE_WORKLOG_FROM_TIMERS, {
    onCompleted({ createWorklogEntriesFromTimers: createdWorklog }) {
      if (createdWorklog) {
        toast('success', 'worklog.create.from.timer.success.toast');
        EventEmitterWithIndex.dispatch('refetchWorklogs');
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        sendMessageToContentJS('refetchGlobalTimers');

        useActivityTracker({
          event: 'Ticket - Adding a time entry on tickets'
        });
        // setTimerItem(null);
        setBillable(true);
        setComments(null);
        formatAndSetSegments([]);
        setTimerId(null);
        // if (handleClose && !disableCloseOnSuccess) handleClose();
        if (handleClose) handleClose();
        if (handleWorklogCreated) handleWorklogCreated(createdWorklog?.[0]);
      }
    }
  });

  const [
    updateWorklogTimerEntryWithInterceptor,
    {
      loading: updateWorklogTimerEntryLoading,
      data: updatedWorklogTimerEntry,
      error: updateWorklogTimerEntryError
    }
  ] = useMutation(UPDATE_WORKLOG_TIMER_ENTRY, {
    onCompleted({ updateWorklogTimerEntry: currentCreatedTimer }) {
      if (currentCreatedTimer) {
        toast('success', 'timer.entry.update.success.toast');
        const currentTimer = currentCreatedTimer;
        const currentTimerItem =
          currentTimer[contractsNew ? 'serviceCatalogItem' : 'serviceItem'];
        const currentBillable = currentTimer.billable;
        const currentTimeSpent = currentTimer.timespent;
        const currentTimerState = currentTimer.state;
        const currentTimerRunning = currentTimer.running;
        const currentNotes = currentTimer.notes;
        const currentWorkItem = currentTimer.workItem;
        setTimerItem(currentTimerItem);
        setBillable(currentBillable);
        setComments(currentNotes);
        formatAndSetSegments(currentTimer?.segments || []);
        setTimerId(currentTimer.timerId);

        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        sendMessageToContentJS('refetchGlobalTimers');
        if (editMode && refetchTimerEntry) {
          refetchTimerEntry(currentTimer.timerId);
        }
        // EventEmitter.dispatch('refetchTimerEntry');
        if (handleClose && !disableCloseOnSuccess) handleClose();
      }
    }
  });

  async function updateWorklogTimerEntry(variables) {
    try {
      const updatedPayload = removePropertiesForItProduct(
        variables,
        'updateWorklogTimerEntry',
        currentProduct
      );
      return await updateWorklogTimerEntryWithInterceptor(updatedPayload);
    } catch (ex) {
      return ex;
    }
  }

  const [
    deleteWorklogTimerEntry,
    {
      loading: deleteWorklogTimerEntryLoading,
      data: deletedEntry,
      error: deleteWorklogTimerEntryError
    }
  ] = useMutation(DELETE_WORKLOG_TIMER, {
    onCompleted(res) {
      if (res?.deleteWorklogTimerEntry) {
        toast('success', 'timer.entry.delete.success.toast');
        // setTimerItem(null);
        setBillable(true);
        setComments(null);
        formatAndSetSegments([]);
        setTimerId(null);

        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        sendMessageToContentJS('refetchGlobalTimers');

        if (handleClose && !disableCloseOnSuccess) handleClose();
      }
    }
  });
  const getClientId = () => {
    return associatedWorkItem?.client?.accountId;
    // switch (module) {
    //   case 'TICKET':
    //     return ticket.client.accountId;
    //   case 'PROJECT':
    //     return project.client.accountId;
    //   default:
    //     break;
    // }
  };

  const contractId = ticket
    ? ticket?.contractTicketMapping?.find((ticketMap) => ticketMap.inUse)
        ?.contract?.contractId
    : project?.contract?.contractId;

  const {
    loading: autoStartConfigLoading,
    data: autoStartConfig,
    error: autoStartConfigError
  } = useQuery(GET_AUTO_START_TIMER_INFO, {
    fetchPolicy: 'cache-and-network',
    skip: !isMSPProduct
  });
  const {
    loading: itemsForTimeTrackingLoading,
    data: itemsForTimeTracking,
    error: itemsForTimeTrackingError
  } = useQuery(
    contractsNew ? GET_ELIGIBLE_SERVICE_ITEMS : GET_WHITELISTED_SERVICE_ITEMS,
    {
      client: AccountClient,
      skip: !associatedWorkItem?.client?.accountId,
      variables: contractsNew
        ? {
            input: {
              ...(contractId && {
                contract: {
                  contractId
                }
              }),
              listInfo: {
                sort: {
                  attribute: 'name',
                  order: 'ASC'
                },
                condition: {
                  joinOperator: 'AND',
                  operands: [
                    {
                      attribute: 'serviceTypeItem.offeringType',
                      operator: 'is',
                      value: 'HOURS'
                    }
                  ]
                }
              }
            }
          }
        : {
            clientId: getClientId(),
            listInfo: {
              sort: {
                attribute: 'name',
                order: 'ASC'
              },
              condition: {
                joinOperator: 'AND',
                operands: [
                  {
                    attribute: 'useAsWorklogItem',
                    operator: 'is',
                    value: true
                  },
                  { attribute: 'quantityType', operator: 'is', value: 'HOURS' }
                ]
              }
            }
          }
    }
  );

  const getConditionOperands = () => {
    const operands = [
      {
        attribute: 'technician.userId',
        operator: 'is',
        value: currentUser?.userId
      }
    ];
    if (workItem?.workId) {
      operands.push({
        attribute: 'workItem.workId',
        operator: 'is',
        value: workItem?.workId
      });
    }
    return operands;
  };

  const getAllTimerEntries = () => {
    const worklogTimerInput = {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: getConditionOperands()
        }
      }
    };
    if (module) {
      worklogTimerInput.module = module;
    }
    TicketClient.query({
      query: GET_ALL_TIMER_ENTRIES,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      variables: {
        worklogTimerInput: worklogTimerInput,
        isItProduct
      }
    }).then((res) => {
      setRunningTimerEntries(res.data);
      setLoading(false);
    });
  };

  const getWorklogEntry = (workLogId) => {
    setLoading(true);
    const operands = [
      {
        attribute: 'itemId',
        operator: 'is',
        value: workLogId
      }
    ];
    const worklogInput = {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: operands
        }
      }
    };
    if (timer?.module || timer?.workItem?.module) {
      worklogInput.module = timer?.module || timer?.workItem?.module;
    }
    // MockTicketClient.query({
    TicketClient.query({
      query: GET_WORKLOG_ENTRIES,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      variables: {
        worklogInput: worklogInput
      }
    }).then((res) => {
      const currentTimer = res.data?.fetchWorklogEntries?.entries[0];
      const currentTimerItem =
        currentTimer[contractsNew ? 'serviceCatalogItem' : 'serviceItem'];
      const currentBillable = currentTimer.billable;
      const currentNotes = currentTimer.notes;
      setTimerItem(currentTimerItem);
      setBillable(currentBillable);
      setComments(currentNotes);
      formatAndSetSegments(currentTimer?.segments || []);
      setTimerId(currentTimer.timerId);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (!editMode) getAllTimerEntries();
    if (workLogEdit && timer?.itemId) getWorklogEntry(timer.itemId);
  }, []);

  useEffect(() => {
    if (props.timer) {
      setTimerItem(
        timer?.[contractsNew ? 'serviceCatalogItem' : 'serviceItem'] || null
      );
      setComments(timer?.notes || null);
      setBillDateTime(
        timer?.billDateTime
          ? dayjs().format(timer.billDateTime)
          : dayjs().format(DATE_TIME_FORMAT)
      );
      setBillable(timer?.billable || null);
      setAfterHours(timer?.afterHours || null);
      setQty(timer?.qty || null);
      formatAndSetSegments(timer?.segments || []);
      setAssociatedWorkItem(workItem || null);
    }
  }, [props.timer, contractsNew]);

  useEffect(() => {
    if (
      highlightRunningTimer &&
      runningTimerEntries?.fetchWorklogTimerEntries?.entries
    ) {
      const runningTimer = runningTimerEntries?.fetchWorklogTimerEntries?.entries?.find(
        (worklogTimer) => {
          return worklogTimer?.running;
        }
      );

      if (runningTimer && !isEmpty(runningTimer)) {
        const currentTimerItem =
          runningTimer[contractsNew ? 'serviceCatalogItem' : 'serviceItem'];
        const currentBillable = runningTimer.billable;
        const currentNotes = runningTimer.notes;
        const currentWorkItem = runningTimer.workItem;
        const currentSegments = runningTimer?.segments;
        setTimerItem(currentTimerItem);
        setBillable(currentBillable);
        setAssociatedWorkItem(currentWorkItem);
        setComments(currentNotes);
        formatAndSetSegments(currentSegments || []);
      }
    }
  }, [runningTimerEntries]);

  const resetWorklog = () => {
    // setTimerItem(null);
    setComments(null);
    setBillDateTime(dayjs().format(DATE_TIME_FORMAT));
    if (associateWorkItem) setAssociatedWorkItem(null);
    setBillable(true);
    setAfterHours(false);
    setQty(null);
    formatAndSetSegments([]);
    // setAssociatedWorkItem(null);
    // setDefaultTimerItem(null);
  };

  const [
    addWorklogEntry,
    { loading: addWorklogLoading, data: addWorklog, error: addWorklogError }
  ] = useMutation(ADD_WORKLOG_ENTRIES, {
    onCompleted({ addWorklogEntries }) {
      EventEmitterWithIndex.dispatch('refetchWorklogs');
      EventEmitterWithIndex.dispatch('refetchGlobalTimers');
      EventEmitter.dispatch('refetchTimerEntries');
      EventEmitterWithIndex.dispatch('refetchTimerEntries');
      sendMessageToContentJS('refetchGlobalTimers');

      // if (workLogEdit) {
      if (handleClose && !disableCloseOnSuccess) handleClose();
      if (handleWorklogCreated) handleWorklogCreated(addWorklogEntries?.[0]);
      // } else {
      if (resetWorklog) resetWorklog();
      // }
      useActivityTracker({
        event: 'Ticket - Adding a time entry on tickets manually'
      });

      if (taskId) {
        useActivityTracker({
          event: 'Added worklog at task - Manual timer'
        });
      }
    }
  });

  const addWorklogEntries = (dta) => {
    if (isAgentChat) {
      if (handleWorklogCreated)
        handleWorklogCreated(dta?.variables?.input?.entries?.[0]);
      return;
    }
    addWorklogEntry(dta);
  };

  const [
    createWorklogEntry,
    {
      loading: createWorklogLoading,
      data: createdWorklog,
      error: createWorklogError
    }
  ] = useMutation(CREATE_WORKLOG_ENTRIES, {
    onCompleted({ createWorklogEntries }) {
      toast('success', 'worklog.create.success.toast');
      EventEmitterWithIndex.dispatch('refetchWorklogs');
      EventEmitterWithIndex.dispatch('refetchGlobalTimers');
      EventEmitter.dispatch('refetchTimerEntries');
      EventEmitterWithIndex.dispatch('refetchTimerEntries');
      resetWorklog();
      useActivityTracker({
        event: 'Ticket - Adding a time entry on tickets manually'
      });
      // if (workLogEdit) {
      if (handleClose && !disableCloseOnSuccess) handleClose();
      if (handleWorklogCreated) handleWorklogCreated(createWorklogEntries?.[0]);
      // } else {
      if (resetWorklog) resetWorklog();
      // }
    }
  });
  const [
    updateWorklogEntryWithInterceptor,
    { loading: updateWorklogLoading, data: updatedData, error: updatError }
  ] = useMutation(UPDATE_WORKLOG_ENTRY, {
    onCompleted(res) {
      if (res.editWorklogEntry) {
        toast('success', 'worklog.update.success.toast');
        EventEmitterWithIndex.dispatch('refetchWorklogs');
        EventEmitterWithIndex.dispatch('refetchGlobalTimers');
        EventEmitter.dispatch('refetchTimerEntries');
        EventEmitterWithIndex.dispatch('refetchTimerEntries');
        sendMessageToContentJS('refetchGlobalTimers');

        // if (workLogEdit) {
        if (handleClose && !disableCloseOnSuccess) handleClose();
        // } else {
        if (resetWorklog) resetWorklog();
        // }
      }
    }
  });

  async function updateWorklogEntry(variables) {
    try {
      const updatedPayload = removePropertiesForItProduct(
        variables,
        'editWorklogEntry',
        currentProduct
      );
      return await updateWorklogEntryWithInterceptor(updatedPayload);
    } catch (ex) {
      return ex;
    }
  }

  const [
    deleteWorklogEntry,
    { loading: deleteWorklogEntryLoading, error: deleteWorklogEntryError }
  ] = useMutation(DELETE_WORKLOG_ENTRY, {
    onCompleted() {
      EventEmitterWithIndex.dispatch('refetchWorklogs');
      if (handleClose && !disableCloseOnSuccess) handleClose();
    }
  });

  const getAIGeneratedNote = () => {
    if (!isEmpty(threadData)) {
      MLClient.query({
        query: AI_WORKLOGNOTE_GENERATE,
        variables: {
          ticketId: threadData?.workItem?.workId,
          conversationThreadId: threadData?.threadId
        }
      }).then((res) => {
        if (res?.data?.convertChatToAIWorklog) {
          setComments(res?.data?.convertChatToAIWorklog?.join(' '));
        }
      });
    }
  };

  useEffect(() => {
    if (isAgentChat) {
      getAIGeneratedNote();
    }

    if (!skipAIWorklogNotes) {
      setAiWorklogNoteLoading(true);
      getAiWorklog({
        variables: {
          text: timer?.notes || timerNote
        }
      });
    }

    EventEmitter.subscribe('resetWorklogContent', resetWorklog);
    EventEmitter.subscribe('aiError', handleAIError);
    return function cleanup() {
      EventEmitter.unsubscribe('resetWorklogContent');
      EventEmitter.unsubscribe('aiError');
    };
  }, []);

  useEffect(() => {
    if (autoStartConfig?.getAutoStartTimerInfo) {
      setDefaultTimerItem(
        autoStartConfig?.getAutoStartTimerInfo?.[
          contractsNew ? 'defaultServiceCatalogItem' : 'defaultServiceItem'
        ]
      );
    }
  }, [autoStartConfig]);

  const handleAssociateWorkItem = (module, workitem) => {
    if (workitem) {
      setAssociatedWorkItem(workitem);
      if (autoStartConfig?.getAutoStartTimerInfo) {
        setDefaultTimerItem(
          autoStartConfig?.getAutoStartTimerInfo?.[
            contractsNew ? 'defaultServiceCatalogItem' : 'defaultServiceItem'
          ]
        );
      }
    }
  };

  if (autoStartConfigLoading || aiWorklogNoteLoading) {
    return (
      <div className="p20 full-width">
        {/* <div className="flex center full-width">
        <SkeletonThumbnail size="small" />
        <div className="ml10 full-width">
          <SkeletonBodyText size="large" lines={1} />
        </div>
      </div>
      <div className="flex center full-width mt10">
        <SkeletonThumbnail size="small" />
        <div className="ml10 full-width">
          <SkeletonBodyText size="large" lines={1} />
        </div>
      </div> */}
        <SkeletonBodyText size="large" lines={3} />
      </div>
    );
  }
  // if (runningTimerEntries?.fetchWorklogTimerEntries?.entries?.length) {
  //   return (
  //     <div className="p20 full-width">
  //       <div>Running timers are there</div>
  //     </div>
  //   );
  // }
  const options = itemsForTimeTracking
    ? formatDataForSelectDropdown(
        itemsForTimeTracking[
          contractsNew
            ? 'getEligibleServiceCatalogItems'
            : 'getWhitelistedServiceItems'
        ]?.items
      )
    : [];
  const selectedItem = timerItem || defaultTimerItem;
  const handlePropChange = (property, value) => {
    switch (property) {
      case 'billable':
        setBillable(value);
        break;
      case 'afterHours':
        setAfterHours(value);
        break;
      case 'timerItem':
        setTimerItem(value);
        break;
      case 'comments':
        setComments(value);
        break;
      case 'billDateTime':
        setBillDateTime(value);
        break;
      case 'qty':
        setQty(value);
        break;
      default:
        break;
    }
  };

  const isTimer = timer?.timerId;

  return (
    <WorklogManualTimerFormWrapper className={`${workLogEdit ? 'pr10' : ''}`}>
      <WorklogManualTimerForm
        intl={intl}
        timer={timer}
        editMode={editMode}
        workLogEdit={workLogEdit}
        options={options}
        associateWorkItem={associateWorkItem}
        reAssociateWorkItem={isTimer}
        // reAssociateWorkItem={!workItem && associatedWorkItem}
        selectedItem={selectedItem}
        itemsForTimeTrackingLoading={itemsForTimeTrackingLoading}
        currentUser={currentUser}
        ticket={workItem}
        project={workItem}
        workItem={associatedWorkItem}
        segments={segments}
        module={module}
        timerItem={timerItem}
        defaultTimerItem={defaultTimerItem}
        comments={comments}
        billable={billable}
        afterHours={afterHours}
        billDateTime={billDateTime}
        qty={qty}
        createWorklogTimerEntry={createWorklogTimerEntry}
        updateWorklogTimerEntry={updateWorklogTimerEntry}
        deleteWorklogTimerEntry={deleteWorklogTimerEntry}
        createWorklogTimerEntryLoading={createWorklogTimerEntryLoading}
        updateWorklogTimerEntryLoading={updateWorklogTimerEntryLoading}
        deleteWorklogTimerEntryLoading={deleteWorklogTimerEntryLoading}
        handlePropChange={handlePropChange}
        addWorklogEntry={addWorklogEntries}
        addWorklogLoading={addWorklogLoading}
        createWorklogEntry={createWorklogEntry}
        updateWorklogEntry={updateWorklogEntry}
        createWorklogEntryFromTimer={createWorklogEntryFromTimer}
        createWorklogEntryFromTimerLoading={createWorklogEntryFromTimerLoading}
        updateWorklogLoading={updateWorklogLoading}
        createWorklogLoading={createWorklogLoading}
        createWorklogError={createWorklogError}
        deleteWorklogEntry={deleteWorklogEntry}
        deleteWorklogEntryLoading={deleteWorklogEntryLoading}
        resetWorklogEntry={resetWorklog}
        // mode={timer ? 'edit' : 'create'}
        itemId={timer?.itemId}
        handleClose={handleClose}
        handleParentClose={handleParentClose}
        associatedWorkItem={associatedWorkItem}
        handleAssociateWorkItem={handleAssociateWorkItem}
        forwardedRef={forwardedRef}
        hideCancel={hideCancel}
        hideWorkitem={hideWorkitem}
        hideDelete={hideDelete}
        worklogAdd={worklogAdd}
        globaltimerSection={globaltimerSection}
        repositionPopup={repositionPopup}
        disableCloseOnSuccess={disableCloseOnSuccess}
        closeOnCancel={!!closeOnCancel && handleClose}
        aiGeneratedNote={aiGeneratedNote}
        setAIgeneratedNote={setAIgeneratedNote}
        timerNote={timerNote}
        isAgentChat={isAgentChat}
        disableSaveTimer={disableSaveTimer}
        taskId={taskId}
        hideWorklogTask={hideWorklogTask}
        hideTaskWorkItem={hideTaskWorkItem}
        taskViewOnly={taskViewOnly}
        hideBlockItemConsumptionInfo={hideBlockItemConsumptionInfo}
      />
    </WorklogManualTimerFormWrapper>
  );
}

export default WorklogManualTimer;
